module.exports = __webpack_public_path__ + "static/img/fish32.e715cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish32.png
// module id = 46tj
// module chunks = 0